// extracted by mini-css-extract-plugin
module.exports = {"links":"downloadButton_links__3UFOF"};